module.exports = __webpack_public_path__ + "img/10.fe2f6142.jpg";